import { HOTJAR_EVENTS } from './consts';

declare global {
  interface Window {
    hj?: (command: string, value?: any) => void;
  }
}

type TriggerEventType = keyof typeof HOTJAR_EVENTS;

export const isValidEvent = (event: string): event is TriggerEventType =>
  event in HOTJAR_EVENTS;

export const triggerHotjarEvent = (event: TriggerEventType) => {
  if (typeof window !== 'undefined' && typeof window.hj === 'function') {
    window.hj('event', HOTJAR_EVENTS[event]);
  } else {
    console.info('hj function not found');
  }
};
